<template>
  <div class="c-recap-mission">
    <div class="c-recap-mission__wrapper">
      <div class="c-recap-mission__icon" v-html="iconTrophy"></div>
      <h2 class="c-recap-mission__title text-primary">
        {{ $t("Hai completato il quiz!") }}
      </h2>
      <div class="c-recap-mission__description">
        {{
          $t("Hai guadagnato un totale di:", {
            correctQuestions: data.correctQuestions,
            totalQuestions: data.allQuestions
          })
        }}
      </div>
      <div class="c-recap-mission__points btn-outline-primary text-primary">
        +{{ data.points }} {{ $t("COINS") }}
      </div>
      <button
        @click="redirectToDashboard"
        class="c-recap-mission__btn btn btn-primary"
      >
        {{ $t("OK") }}
      </button>
    </div>
  </div>
</template>

<script>
import iconTrophy from "@/assets/svg/rebuild/icon_trofeo.svg";
export default {
  name: "RecapMission",
  props: ["data"],
  data() {
    return {
      iconTrophy
    };
  },
  methods: {
    redirectToDashboard() {
      this.$router.push("/dashboard");
    }
  }
};
</script>

<style lang="scss" scoped>
.c-recap-mission {
  padding: 70px 30px;
  @media (min-width: 767px) {
    box-shadow: 0 7.5px 17px 0 rgba(0, 0, 0, 0.07);
    border-radius: 15px;
    background-color: #fff;
    margin-top: 20px;
    max-width: 600px;
    margin: 0 auto;
  }
}
.c-recap-mission__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.c-recap-mission__icon {
  font-weight: bold;
}
.c-recap-mission__title {
  font-size: 25px;
  margin-bottom: 10px;
  line-height: 1.8;
}
.c-recap-mission__description {
  color: #9a9a9a;
  font-size: 20px;
  margin-bottom: 30px;
}
.c-recap-mission__points {
  font-size: 25px;
  font-weight: bold;
  border-bottom-width: 3px;
  border-bottom-style: solid;
  margin-bottom: 40px;

  &:hover,
  &:active {
    background-color: transparent;
  }
}
.c-recap-mission__btn {
  font-weight: bold;
  padding: 8px 60px;
}
</style>
